import * as React from "react";
import { useResource, Resources } from "Translations/Resources";
import { AccessRightCodes } from "Components/Models/AccessRights";
import { SubMenu } from "Components/Shared/Menu/SubMenu";
import { isNoU } from "Utils/ObjectUtils";
import { useHasCurrentUserAccessRight } from "Hooks/useHasCurrentUserAccessRight";
import { necessaryAccessRightEditForCompanies } from "Hooks/useHasCurrentUserAccessRight";
import { useDispatch, useSelector } from "react-redux";
import { getCompaniesDetailAsync } from "State/Companies/CompanyReducer";
import { RootStateType } from "State/Store";

type Props = {
  companyID: number;
};

export const CompaniesSideMenu: React.FunctionComponent<Props> = props => {
  const { companyID } = props;
  const { t } = useResource();
  const hasAccessRight = useHasCurrentUserAccessRight();
  const dispatch = useDispatch();

  const {
    companyDetail: company,
    isLoadingCompanyDetail: isLoading,
  } = useSelector((e: RootStateType) => e.companies);

  React.useEffect(() => {
    if (companyID) {
      dispatch(getCompaniesDetailAsync.request(companyID));
    }
  }, [companyID, dispatch]);

  function getMenuItems() {
    let menuItems = [
      {
        name: t(Resources.Companies.Detail.Title),
        url: `/${t(Resources.Routes.Companies)}/${t(
          Resources.Routes.CompanyDetail,
        )}/${companyID}`,
      },
      /* ,
      {
        name: "Historie sazeb",
        url: `/${t(Resources.Routes.Companies)}/hisorie-sazeb/${companyID}`,
      }, */
    ];

    if (
      hasAccessRight(
        necessaryAccessRightEditForCompanies(
          company?.isCustomer,
          company?.isSupplier,
          company?.isMarketplaceEnabled,
        ),
      )
    ) {
      menuItems.push({
        name: t(Resources.CompanyEdit.Title),
        url: `/${t(Resources.Routes.Companies)}/${t(
          Resources.Routes.CompanyEdit,
        )}/${companyID}`,
      });
    }

    menuItems.push({
      name: "Kontaktní osoby",
      url: `/${t(Resources.Routes.Companies)}/kontaktni-osoby/${companyID}`,
    });

    return menuItems;
  }

  return (
    <>
      {!isLoading && !isNoU(companyID) && (
        <SubMenu
          menuItems={getMenuItems()}
          accessRight={[
            AccessRightCodes.Core_Company_Customer_Read,
            AccessRightCodes.Core_Company_Supplier_Read,
          ]}
        />
      )}
    </>
  );
};
